module.exports = __webpack_public_path__ + "img/外圈箭头.49aac24a.png";